// Module-level variable — intentionally NOT persisted (clears on page refresh).
// Used to pass signup data into the onboarding flow without a token.
let data = null;
// let data={
//                             pubId: "6a687a02bceedbc97c5f100f",
//                             signupData: {
//         "_id": "6a687a02bceedbc97c5f100f",
//         "email": "test_v12@yopmail.com",
//         "p_name": "test_v12",
//         "o_name": "xapads",
//         "im": {
//             "telegram": "9999999999"
//         },
//         "c_website": "xapads.com"
//     },
//                         }

export const setRegisterFlowData = (d) => { data = d; };
// export const setRegisterFlowData = (d) => { data = {
//                             pubId: "6a687a02bceedbc97c5f100f",
//                             signupData: {
//         "_id": "6a687a02bceedbc97c5f100f",
//         "email": "test_v12@yopmail.com",
//         "p_name": "test_v12",
//         "o_name": "xapads",
//         "im": {
//             "telegram": "9999999999"
//         },
//         "c_website": "xapads.com"
//     },
//                         }; };
export const getRegisterFlowData = () => data;
export const clearRegisterFlowData = () => { data = null; };

